import { z } from 'zod';
const greetingMessageSchema = z.object({
    enabled: z.boolean(),
    text: z.string().min(1).max(4096),
});
export const updateChatGreetingSettingsSchema = z.object({
    welcome: greetingMessageSchema.partial().optional(),
    goodbye: greetingMessageSchema.partial().optional(),
});
export { parseChatGreetingSettings } from '@irl/types';
//# sourceMappingURL=chat-greetings.js.map